import { render, staticRenderFns } from "./AttacksCountByMentions.vue?vue&type=template&id=39bead55&scoped=true"
import script from "./AttacksCountByMentions.vue?vue&type=script&lang=ts"
export * from "./AttacksCountByMentions.vue?vue&type=script&lang=ts"
import style0 from "./AttacksCountByMentions.vue?vue&type=style&index=0&id=39bead55&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bead55",
  null
  
)

export default component.exports